module.exports = __webpack_public_path__ + "static/media/scyre-color.add4c4f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/scyre-color.png
// module id = 390
// module chunks = 0